// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".Mx4Es{height:468px;border-top:1px solid #e2e2e2;border-bottom:1px solid #e2e2e2;background-color:#fff}.sDHHA{justify-content:space-between;padding:24px 16px;font-family:\"Merriweather\",serif;font-size:22px;font-weight:700;line-height:28px}.sDHHA,.sDHHA span{display:flex;align-items:center}.sDHHA span{width:40px;height:21px;justify-content:center;background-color:#0e8912;border-radius:4px;color:#fff;font-size:13px;font-weight:400;line-height:18px}.O2eZT{position:relative;height:calc(100% - 76px);padding:0 16px 24px}.-ymGu{display:flex}.-ymGu+.-ymGu{margin-top:16px}.eqfFM{width:128px;height:80px;flex:0 0 128px;border-radius:8px}img.eqfFM{-o-object-fit:cover;object-fit:cover}._3F17a{padding-left:16px;color:#2d2d2d;font-size:15px;line-height:20px}._3F17a>span{-webkit-line-clamp:4;-webkit-box-orient:vertical;display:block;display:-webkit-box;overflow:hidden;max-height:80px}.VTTyI{position:absolute;top:50%;left:50%;transform:translate(-50%,-50%)}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"root": "Mx4Es",
	"header": "sDHHA",
	"body": "O2eZT",
	"item": "-ymGu",
	"image": "eqfFM",
	"content": "_3F17a",
	"loader": "VTTyI"
};
module.exports = ___CSS_LOADER_EXPORT___;
